/* istanbul ignore file */

// Breakpoints

export const SCREEN_XS = 480 as const;
export const SCREEN_SM = 768 as const;
export const SCREEN_MD = 1024 as const;
export const SCREEN_LG = 1280 as const;
export const SCREEN_XL = 1600 as const;
export const SCREEN_MASSIVE = 1920 as const;

const MOBILE_XS = `@media (max-width: ${SCREEN_XS - 1}px)` as const;
const MOBILE = `@media (max-width: ${SCREEN_SM - 1}px)` as const;
const TABLET = `@media (min-width: ${SCREEN_SM}px) and (max-width: ${SCREEN_MD - 1}px)` as const;
const DESKTOP = `@media (min-width: ${SCREEN_MD}px)` as const;
const DESKTOP_LG = `@media (min-width: ${SCREEN_LG}px)` as const;
const DESKTOP_XL = `@media (min-width: ${SCREEN_XL}px)` as const;
const DESKTOP_MASSIVE = `@media (min-width: ${SCREEN_MASSIVE}px)` as const;

const EXCLUDE_MOBILE_XS = `@media (min-width: ${SCREEN_XS + 1}px)` as const;
const EXCLUDE_MOBILE = `@media (min-width: ${SCREEN_SM}px)` as const;
const EXCLUDE_TABLET = `@media (max-width: ${
  SCREEN_XS - 1
}px) and (min-width: ${SCREEN_MD}px)` as const;
const EXCLUDE_DESKTOP = `@media (max-width: ${SCREEN_MD - 1}px)` as const;
const EXCLUDE_DESKTOP_LG = `@media (max-width: ${SCREEN_LG - 1}px)` as const;
const EXCLUDE_DESKTOP_XL = `@media (max-width: ${SCREEN_XL - 1}px)` as const;

const MEDIA_QUERY_V2 = {
  MOBILE_XS,
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_LG,
  DESKTOP_XL,
  DESKTOP_MASSIVE,
  EXCLUDE_MOBILE_XS,
  EXCLUDE_MOBILE,
  EXCLUDE_TABLET,
  EXCLUDE_DESKTOP,
  EXCLUDE_DESKTOP_LG,
  EXCLUDE_DESKTOP_XL,
} as const;

export default MEDIA_QUERY_V2;
